"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Header_1 = require("./Header");
const Header = (props) => {
    return (0, jsx_runtime_1.jsx)(Header_1.Header, Object.assign({}, props));
};
exports.Header = Header;
